import { Chip, ChipProps } from '@mui/material';

export interface ChipXsProps extends Omit<ChipProps, 'size'> {
  /** Label text or node (e.g. from $t() or FormattedMessage). */
  label: ChipProps['label'];
  /** MUI color (e.g. "info", "default", "primary"). */
  color?: ChipProps['color'];
  /** MUI variant ("filled" or "outlined"). */
  variant?: ChipProps['variant'];
}

/**
 * Extra-small chip with compact typography (caption, uppercase). Use for tight UIs (e.g. list rows, inline badges).
 * Fixed height 16px and minimal padding. Caller must pass color and variant.
 */
export function ChipXs({ label, color, variant, sx, ...rest }: ChipXsProps) {
  return (
    <Chip
      label={label}
      size="small"
      color={color}
      variant={variant}
      sx={{
        height: '16px',
        '& .MuiChip-label': {
          typography: 'caption',
          textTransform: 'uppercase',
          fontSize: '10px',
          fontWeight: 500,
          p: '0px 4px',
        },
        ...sx,
      }}
      {...rest}
    />
  );
}
